import React from 'react'
import PropTypes from 'prop-types'
import ExitToApp from '@material-ui/icons/ExitToApp'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import { useStyles } from './signInfo.css'

const SignInInfo = (props) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (event) => {
    setAnchorEl(null)
  }
  const handleLogout = (event) => {
    handleClose(event)
    props.logout()
  }

  const { localize, oidc } = props
  const userName = oidc.user && oidc.user.profile && oidc.user.profile.name
  const title = (oidc.user && oidc.user.profile ? `${localize('common.signedInUser')} ${userName}` : '')
  return (
    <div className={classes.userInfo} >
      <div className={classes.userName} title={title} onClick={handleClick}>{userName}</div>
      <Menu
        id='account-menu'
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorEl)}
        onClose={handleClose}>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon><ExitToApp /></ListItemIcon>
          <ListItemText>{localize('common.logout')}</ListItemText>
        </MenuItem>
      </Menu>
    </div>
  )
}
SignInInfo.propTypes = {
  localize: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  oidc: PropTypes.object
}

export {
  SignInInfo
}